/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_3_TInputs */

const en_cp_cal_3_t = /** @type {(inputs: Cp_Cal_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprints 1–2`)
};

const id_cp_cal_3_t = /** @type {(inputs: Cp_Cal_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint 1–2`)
};

/**
* | output |
* | --- |
* | "Sprints 1–2" |
*
* @param {Cp_Cal_3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_3_t = /** @type {((inputs?: Cp_Cal_3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_3_t(inputs)
	return en_cp_cal_3_t(inputs)
});